import React, { Component } from 'react';
import { Icon, Menu } from "antd";
import ExportPdf from "./ExportPdf";
import { authData } from "../setting/data";
import SelectHotel from "../../bp-views/app/SelectHotel";
import logo from "../../assets/logo.png";
import { inject, observer } from "mobx-react";
import IsAuth from "./IsAuth";

const SubMenu = Menu.SubMenu;
const routeData = {
    '/table/2_1': 'sub2',
    '/table/2_2': 'sub2',
    '/table/2_3': 'sub2',
    '/table/2_4': 'sub3',
    '/table/2_5': 'sub3',
    '/table/2_6': 'sub3',
    '/table/2_7': 'sub3',
    '/table/2_8': 'sub3',
    '/table/2_9': 'sub3',
    '/table/3_1': 'sub4',
    '/table/3_2': 'sub5',
    '/table/3_3': 'sub6',
    '/table/4_1': 'sub4',
    '/table/4_2': 'sub4',
    '/table/4_3': 'sub4',
    '/table/4_4': 'sub4',
    '/table/4_5': 'sub4',
    '/table/5_1': 'sub5',
    '/table/5_2': 'sub5',
    '/table/5_3': 'sub5',
    '/table/5_5': 'sub5',
    '/table/5_6': 'sub5',
    '/table/5_7': 'sub5',
    '/table/6_1': 'sub6',
    '/table/6_2': 'sub6',
    '/table/6_3': 'sub6',
    '/table/6_4': 'sub6',
    '/table/6_5': 'sub6',
    '/table/7_1': 'sub7',
    '/table/7_2': 'sub7',
    '/table/7_3': 'sub7',
    '/table/7_4': 'sub7',
    '/table/7_5': 'sub7',
    '/table/7_6': 'sub7',
    '/table/8_1': 'sub8',
    '/table/8_2': 'sub8',
    '/table/9_1': 'sub9',
    '/table/9_2': 'sub9',
    '/table/9_3': 'sub9',
    '/table/9_4': 'sub9',
    '/table/9_5': 'sub9',
    '/table/9_6': 'sub9',
    '/table/9_7': 'sub9',
    '/table/10': 'sub10',
    '/table/9_8': 'sub9',
    '/table/cover': 'Executive Summary Version',
    '/table/meetingflash': 'Executive Summary Version',
    '/table/1': 'Executive Summary Version',
    '/table/performancedescription': 'hoteldataindex',
    '/table/performanceAnalysis': 'hoteldataindex',
    '/table/analysisChart': 'hoteldataindex',
    '/table/guestrating': 'guestratingAll',
    '/table/groupOfChannels': 'guestratingAll',
    '/table/profit': 'headquarters_menu',
    '/table/efficiency': 'hoteldataindex',
    '/table/effictdescription': 'hoteldataindex',
}

@inject('store')
@observer
class MenuApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "",
            openKeys: ['sub1'],
            selectedKeys: [''],
            user: {},
            data: JSON.parse(sessionStorage.getItem('esTD') || "[]") || [],
        }
    }
    rootSubmenuKeys = ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7', 'sub8', 'sub9', 'Executive Summary Version', '/bp', '/hr', '/table/comments', '/table/compared', '/table/pdf'];

    async componentDidMount() {

        try {
            let auth = [], data = [];
            if (!this.props.store.auth.ES || this.props.store.auth.ES.length <= 0) {
                await this.props.store.auth.getESAuth();
            }
            auth = this.props.store.auth.ES;
            const getAuth = this.props.store.auth.getAuth
            authData.forEach(item => {
                let children = [];
                if (item.children[0].title === '查看' && getAuth('ES', item.children[0].key)) {
                    data.push({
                        ...item,
                    })
                } else if (item.children && item.children[0].title != '查看') {
                    item.children.forEach(x => {

                        let _item = x;
                        if (x.children[0].title === '查看' && getAuth('ES', x.children[0].key)) {
                            children.push(_item);
                        } else if (x.children && x.children[0].title != '查看') {
                            let _children = [];
                            x.children.forEach(y => {
                                if (y.children && y.children[0].title === '查看' && getAuth('ES', y.children[0].key)) {
                                    _children.push(y);
                                }
                            });
                            if (_children.length) children.push({ ..._item, children: _children });
                        }
                    });

                    if (children.length > 0) {
                        data.push({
                            ...item,
                            children
                        })
                    }
                }
            })
            sessionStorage.setItem('esTD', JSON.stringify(data));
            const path = window.location.href.split('#')[1];

            this.setState({
                selectedKeys: [path],
                openKeys: routeData[path] ? ['Executive Summary Version', routeData[path]] : [],
                user: this.props.store.auth.user || {},
                data
            });
        } catch (error) {
            console.error(error);
        }
    }

    onOpenChange = (openKeys) => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
        } else {
            this.setState({
                openKeys: latestOpenKey ? ['Executive Summary Version', latestOpenKey] : [],
            });
        }
    }

    onPush = (path) => {
        this.props.history.push(path);
    }

    render() {
        const { display, onChangeDisplay } = this.props.store.menu;
        const isView = this.props.store.auth.isView;
        const noListMenu = ['/table/pdf', "/bp", "/hr", "/table/week", '/table/headquarters', '/table/charter', '/table/daily', "/table/guestrating", "/table/guestratingAll", "/table/guestrating", "/table/profit", "/table/hoteldataindex", "/table/Consulting", '/table/consulting', '/table/urgent'];
        const width = document.getElementsByClassName('app-content')[0] && (document.getElementsByClassName('app-content')[0].offsetWidth - 300 <= 0);
        let user = {};
        try {
            user = JSON.parse(sessionStorage.getItem('user')) || {};
        } catch (error) {
            console.error(error);
        }
        if (display) {
            return (
                <div className={`app-menu `}>

                    <div
                        className={`app-content ${display && width ? 'Expand' : 'shrink'}`}
                    >
                        <div className={`menu-select-export ${display && width ? 'Expand' : 'shrink'}`}>
                            <div style={{ display: "flex", alignItems: 'center', justifyContent: "space-between" }}>
                                <img src={logo} alt="" style={{ width: "calc(100% - 50px)" }} />
                                <Icon
                                    type="menu-fold"
                                    theme="outlined"
                                    style={{ float: "right", fontSize: 24 }}
                                    onClick={() => {
                                        onChangeDisplay('');
                                    }}
                                />
                            </div>
                        </div>
                        <div className="menu-list">
                            {(this.state.user.email || "").includes('admin') ? < SelectHotel user={this.state.user} display={display} /> : null}
                            <Menu
                                mode="inline"
                                openKeys={this.state.openKeys}
                                selectedKeys={this.state.selectedKeys}
                                onOpenChange={this.onOpenChange}
                                style={{ width: 340, marginLeft: -20 }}
                                // className={`${display ? 'animation' : ''}`}
                                onSelect={(item, key) => {
                                    this.setState({
                                        selectedKeys: [item.key]
                                    });
                                }}
                            >

                                {isView && (this.state.data || []).some(x => x.key === "/table/guestratingAll") ?
                                    <SubMenu key={`guestratingAll`} title={<span>Customer Satisfaction <br /> 客人满意度</span>}>
                                        {((this.state.data || []).find(x => x.key === "/table/guestratingAll") || []).children.map(item => {
                                            return (
                                                <Menu.Item key={item.key}>
                                                    <div className="menu_click" onClick={this.onPush.bind(this, item.key)}>
                                                        {item.title}
                                                    </div>
                                                </Menu.Item>
                                            )
                                        })}
                                    </SubMenu> : null}
                                {isView && (this.state.data || []).some(x => x.key === "/table/urgent") ? <Menu.Item key="/table/urgent">
                                    <div className="menu_click" onClick={this.onPush.bind(this, "/table/urgent")}>
                                        Hotel Emergency Report <br /> 酒店紧急事件报告
                                    </div>
                                </Menu.Item> : null}

                                {/* Hotel Data Index 酒店数据分析 */}
                                {isView && <SubMenu key={`hoteldataindex`} title={<span>Hotel Data Index <br /> 酒店数据分析</span>}>
                                    {(((this.state.data || []).find(x => x.key === "/table/hoteldataindex") || []).children || []).map(x => {
                                        return (
                                            <SubMenu key={`sub${x.title.split('.')[0]}`} title={<span dangerouslySetInnerHTML={{ __html: x.title }}></span>}>
                                                {(x.children || []).map(item => {
                                                    return (
                                                        <Menu.Item key={item.key}>
                                                            <div
                                                                className="menu_click"
                                                                onClick={this.onPush.bind(this, item.key)}
                                                                dangerouslySetInnerHTML={{ __html: item.title }}
                                                            ></div>
                                                        </Menu.Item>
                                                    )
                                                })}
                                            </SubMenu>
                                        )
                                    })}
                                </SubMenu>}
                                {/* Consulting Reports 第三方行业资讯报告摘要 */}
                                {isView && (this.state.data || []).some(x => x.key === "/table/consulting") ? <Menu.Item key="/table/consulting">
                                    <div className="menu_click" onClick={this.onPush.bind(this, "/table/consulting")}>
                                        Consulting Reports <br /> 第三方行业资讯报告摘要
                                    </div>
                                </Menu.Item> : null}
                                {(this.state.data || []).some(x => x.key === "/table/daily") ? <Menu.Item key='/table/daily'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/table/daily')}>
                                        Daily Revenue Report<br /> 每日经营报表
                                    </div>
                                </Menu.Item> : null}
                                {isView && (this.state.data || []).some(x => x.key === "/table/week") ? <Menu.Item key='/table/week'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/table/week')}>
                                        Weekly Flash Report<br />  周度即时报表
                                    </div>
                                </Menu.Item> : null}

                                <SubMenu key="Executive Summary Version" title={<span>Executive Summary Report <br /> 月度经营报告</span>}>
                                    {this.state.data.map((x, i) => {
                                        if (noListMenu.includes(x.key)) {
                                            return
                                        }
                                        if (x.children[0].title === '查看') {
                                            return (
                                                <Menu.Item key={x.key}>
                                                    <div
                                                        className="menu_click"
                                                        onClick={this.onPush.bind(this, x.key)}
                                                        dangerouslySetInnerHTML={{ __html: x.title }}
                                                    ></div>
                                                </Menu.Item>
                                            )
                                        } else {
                                            return (
                                                <SubMenu key={`sub${x.title.split('.')[0]}`} title={<span dangerouslySetInnerHTML={{ __html: x.title }}></span>}>
                                                    {(x.children || []).map(item => {
                                                        if (item.children[0].title === '查看') {
                                                            return (
                                                                <Menu.Item key={item.key}>
                                                                    <div
                                                                        className="menu_click"
                                                                        onClick={this.onPush.bind(this, item.key)}
                                                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                                                    ></div>
                                                                </Menu.Item>
                                                            )
                                                        }
                                                        return <SubMenu key={`sub${item.title}`} title={<span dangerouslySetInnerHTML={{ __html: item.title }}></span>}>
                                                            {(item.children || []).map(_item => {
                                                                if (_item.children[0].title === '查看') {
                                                                    return (
                                                                        <Menu.Item key={_item.key}>
                                                                            <div
                                                                                className="menu_click"
                                                                                onClick={this.onPush.bind(this, _item.key)}
                                                                                dangerouslySetInnerHTML={{ __html: _item.title }}
                                                                            ></div>
                                                                        </Menu.Item>
                                                                    )
                                                                }
                                                                return

                                                            })}
                                                        </SubMenu>

                                                    })}
                                                </SubMenu>
                                            )
                                        }
                                    })}
                                </SubMenu>
                                {/* is_charter == 1 特许酒店 */}
                                {isView && user.is_charter && user.is_charter == 1 && (this.state.data || []).some(x => x.key === "/table/charter") ?
                                    <SubMenu key={`subcharter`} title={<span>Simple Report <br /> 简易数据汇总表</span>}>
                                        {((this.state.data || []).find(x => x.key === "/table/charter") || []).children.map(item => {
                                            return (
                                                <Menu.Item key={item.key}>
                                                    <div
                                                        className="menu_click"
                                                        onClick={this.onPush.bind(this, item.key)}
                                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                                    ></div>
                                                </Menu.Item>
                                            )
                                        })}
                                    </SubMenu> : null}
                                {(this.state.data || []).some(x => x.key === "/bp") ? <Menu.Item key='/bp'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/bp')}>
                                        Business Plan<br />  年度经营预算
                                    </div>
                                </Menu.Item> : null}
                                {/* hr */}
                                {(this.state.data || []).some(x => x.key === "/hr") ? <Menu.Item key='hr'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/hr')}>
                                        Human Resources <br /> 人力资源报告
                                    </div>
                                </Menu.Item> : null}

                                {isView && (this.state.user.email || '').includes('admin') ? <Menu.Item key='/table/comments'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/table/comments')}>
                                        Corporate Office Review<br />  集团信息汇总
                                    </div>
                                </Menu.Item> : null}
                                {(this.state.user.email || '').includes('admin') ? <Menu.Item key='/table/compared'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/table/compared')}>
                                        Custom Table <br /> 自定义表格
                                    </div>
                                </Menu.Item> : null}
                                {isView && (this.state.data || []).some(x => x.key === "/table/pdf") ? <Menu.Item key='/table/pdf'>
                                    <div className="menu_click" onClick={this.onPush.bind(this, '/table/pdf')}>
                                        PDF Version PDF<br />  报表
                                    </div>
                                </Menu.Item> : null}
                                {/* 总部菜单列表 */}
                                {(this.state.user.email || "").includes('admin') ?
                                    <SubMenu key={`headquarters_menu`} title={<span>Headquarters Menu Summary <br />总部菜单汇总</span>}>
                                        {(((this.state.data || []).find(x => x.key === "/table/headquarters") || []).children || []).map(x => {
                                            if (x.children[0].title === '查看') {
                                                return (
                                                    <Menu.Item key={x.key}>
                                                        <div
                                                            className="menu_click"
                                                            onClick={this.onPush.bind(this, x.key)}
                                                            dangerouslySetInnerHTML={{ __html: x.title }}
                                                        ></div>
                                                    </Menu.Item>
                                                )
                                            } else {
                                                return (
                                                    <SubMenu key={`sub${x.title.split('.')[0]}`} title={<span dangerouslySetInnerHTML={{ __html: x.title }}></span>}>
                                                        {(x.children || []).map(item => {
                                                            return (
                                                                <Menu.Item key={item.key}>
                                                                    <div className="menu_click" onClick={this.onPush.bind(this, item.key)}>
                                                                        {item.title}
                                                                    </div>
                                                                </Menu.Item>
                                                            )
                                                        })}
                                                    </SubMenu>
                                                )
                                            }
                                        })}
                                    </SubMenu> : null}
                            </Menu>
                        </div>
                        <ExportPdf />
                    </div>
                </div >
            );
        }

        return null

    }
}

export default MenuApp;


// WEBPACK FOOTER //
// ./src/components/app/Menu.js